import type { ExclusionArea, ExclusionAreaGeoJSON } from '../../../types/apiModels'
import { apiClient } from '../../ruutsApi/client'
import endpoints from '../../ruutsApi/endpoints'
import { unwrapCollection } from '../../ruutsApi/normalize'

export const getExclusionAreasByFarm = async ({
  farmId,
  signal,
}: {
  farmId: string
  signal?: AbortSignal
}): Promise<ExclusionAreaGeoJSON[]> => {
  const response = await apiClient.get(endpoints.exclusionAreas, { params: { farmId }, signal })
  return unwrapCollection<ExclusionArea>(response)
    .sort((a, b) => a?.name.localeCompare(b?.name))
    .map(exclusionArea => exclusionArea.toGeoJSON)
}
